 
import $ from 'jquery';
import ko from 'knockout';
import Question from './question';

export default function Category(data) {
    $.extend(this, data, {
        showTitle: ko.observable(data.showTitle)
    });

    this.questions = ko.observableArray(
        data.questions.map(question => new Question(question))
    );

    this.done = ko.computed(() => {
        return this.questions().filter(question => !!question.response());
    });
}